import React from 'react';
import styles from './TextField.module.scss';

const TextField = ({ label, name, type = 'text', required = false, ...props }) => {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={name}>
        {label}
        {required && '*'}
      </label>
      <input type={type} id={name} name={name} required={required} {...props} />
    </div>
  );
};

export default TextField;
